/* eslint-disable import/prefer-default-export */
/**
 * Enumeration for RFC validation types, used to specify the type of RFC format to validate.
 */
export enum TaxIdValidation {
  /** Generic RFC validation, applicable to all types. */
  GENERIC = 'GENERIC',

  /** RFC validation specifically for companies (legal entities) in Mexico. */
  COMPANY = 'COMPANY',

  /** RFC validation specifically for individuals (natural persons) in Mexico. */
  PERSON = 'PERSON',

  /** Tax Identification Number (TIN) validation for the USA. */
  USA = 'USA',

  /** Tax Identification Number (NIT) validation for Colombia. */
  COLOMBIA = 'COLOMBIA',
}
